import * as sentry from '@sentry/react';
import {call, put, select, takeLatest} from 'redux-saga/effects';

import {getUserAddresses} from 'services/address-strategy';
import {
  fetchUserAddressesAction,
  setUserAddressesAction,
  updateBasketAddressAction,
  setSelectedAddressAction
} from 'store/actions/addresses-action';
import {AddressesState} from 'store/types/addresses';
import {AppState} from 'store/types/app';
import {AddressTypeEnum, UserAddress} from 'types';
import {fetchShippingAddress as findRelevantAddress, isSyncAddressEnabled} from 'utils/helper';

function* fetchUserAddressesSaga(): Generator {
  const accessToken = yield select((state) => state.auth?.idToken);
  try {
    const userAddresses = yield call(() => getUserAddresses(accessToken as string, AddressTypeEnum.SHIPPING));
    if (userAddresses) {
      yield put(setUserAddressesAction(userAddresses as UserAddress[]));
    }
  } catch (e: any) {
    const extra = {idToken: accessToken};
    sentry.captureException(e, {extra});
  }
}

function* updateBasketAddressesSaga(): Generator {
  try {
    const {availableAddresses, selectedShippingAddress} = (yield select(
      (state) => state.addresses
    ) as unknown) as AddressesState;

    const {currentStore} = (yield select((state) => state.app) as unknown) as AppState;
    const isSyncAddress = isSyncAddressEnabled();
    let relevantAddress;

    if (isSyncAddress) {
      relevantAddress = findRelevantAddress(availableAddresses, currentStore);
    } else {
      const savedAddressId = localStorage.getItem('selectedShippingAddressId');
      const savedAddress = availableAddresses.find((address) => savedAddressId && address.id === savedAddressId);
      if (
        savedAddress &&
        savedAddress.zip === currentStore?.zipcode &&
        (savedAddress.subDistrict?.nameEn === currentStore.subdistrict ||
          savedAddress.subDistrict?.nameTh === currentStore.subdistrict)
      ) {
        relevantAddress = savedAddress;
      } else if (!selectedShippingAddress?.id) {
        relevantAddress = findRelevantAddress(availableAddresses, currentStore);
      }
      localStorage.setItem('selectedShippingAddressId', relevantAddress?.id || '');
    }
    yield put(setSelectedAddressAction(relevantAddress));
  } catch (e: any) {
    sentry.captureException(e);
  }
}

export default function* () {
  yield takeLatest(fetchUserAddressesAction, fetchUserAddressesSaga);
  yield takeLatest(updateBasketAddressAction, updateBasketAddressesSaga);
}
